import { authSubscription } from './AuthStore';
import { authSubscriptionDefault } from './AuthStoreDefaults';

export const resetAuthSubscription = () => authSubscription.set(authSubscriptionDefault);
